import { createAsyncThunk } from 'app/store/utils';
import axios from 'axios';

import { StorageResponse } from 'app/components/Storage/types';
import { addAlertAction } from 'app/store/Alerts/slice';
import { getStorageLink } from './selectors';

export const fetchStorageEffect = createAsyncThunk(
  'storage/fetchStorage',
  async (_, { dispatch, getState }) => {
    const link = getStorageLink(getState());

    if (!link) {
      throw new Error('Fetch storage link not found');
    }

    try {
      const response = await axios.request<StorageResponse>({
        url: link.href,
        method: link.method,
        withCredentials: true,
      });

      return response.data.response.storage;
    } catch (e) {
      dispatch(
        addAlertAction({
          message:
            'Failed to get storage. Please refresh the page and try again',
        })
      );
      throw e;
    }
  }
);
